import { render, staticRenderFns } from "./CaseItemM.vue?vue&type=template&id=1d886316&scoped=true"
import script from "./CaseItemM.vue?vue&type=script&lang=ts"
export * from "./CaseItemM.vue?vue&type=script&lang=ts"
import style0 from "./CaseItemM.vue?vue&type=style&index=0&id=1d886316&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d886316",
  null
  
)

export default component.exports